export default {
  disabled: {
    title: 'Rozliczenia nie są zarządzane na platformie',
    description:
      'Subskrypcje i faktury nie są dostępne, ponieważ rozliczenia między Tobą a Twoimi restauracjami są realizowane poza platformą. Wypłaty, zestawienia i raporty pozostają dostępne.',
  },
};
